import React from 'react';
import styles from './FormError.module.scss';

const FormError = (props) => {
  return (
    <span style={props.style ? props.style : null} className={styles.error}>
      {props.value}
    </span>
  );
};

export default FormError;
